export enum VirtualPassProviderEnum {
  GOOGLE = 'google',
  APPLE = 'apple'
}
